import { Box, Chip, Typography } from "@mui/material";

import { Paper } from "@mui/material";

import { Stack } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import api from "../api";
import { useSnackbar } from "notistack";
import { useEffect, useState } from "react";
import CustomDataGrid from "../components/CustomDataGrid";
import { getBackendUrl } from "../util/envFn";
import { formatDate } from "../util/date";

type Application = {
    _id: string;
    jobId: string;
    userId: string;
    accepted: boolean;
    appliedAt: string;
    jobTitle: string;
    userEmail: string;
}

const Applications = () => {
    const [applications, setApplications] = useState<Application[]>([]);
    const [loading, setLoading] = useState(true);
    const { enqueueSnackbar } = useSnackbar();

    useEffect(() => {
        api.get(getBackendUrl('/applications'))
            .then(res => {
                setApplications(res.data.map((application: Application) => ({
                    ...application,
                    id: application._id,
                })));
                setLoading(false);
            })
            .catch(error => {
                enqueueSnackbar('Error fetching applications:', { variant: 'error' });
                setLoading(false);
            });
    }, []);

    const columns: GridColDef[] = [
        { field: 'jobTitle', headerName: 'Job', width: 200 },
        { field: 'userEmail', headerName: 'User', width: 200 },
        {
            field: 'appliedAt', headerName: 'Applied At', width: 200,
            renderCell: (params) => <Box>{formatDate(params.row.appliedAt)}</Box>
        },
        {
            field: 'accepted', headerName: 'Status', width: 200,
            renderCell: (params) => params.row.accepted ? <Chip label="Accepted" color="success" /> : <Chip label="Pending" color="warning" />
        },
    ];

    return (
        <Stack maxWidth="100dvw" overflow="auto">
            <Stack padding={2} gap={3}>
                <Typography variant="h4" component="h2">
                    Your Applications
                </Typography>
                <Paper elevation={3} sx={{ height: 400, maxWidth: '100%' }}>
                    <CustomDataGrid
                        rows={applications}
                        columns={columns}
                        initialState={{
                            pagination: {
                                paginationModel: { page: 0, pageSize: 5 },
                            },
                        }}
                    />
                </Paper>
            </Stack>
        </Stack>
    )
}

export default Applications;
